import { notify } from "../../../util/notify";
import React, { useState } from "react";
import { useHistory, useLocation, useParams, Link } from "react-router-dom";
import axios from "axios";
import { FaLock, FaEye, FaEyeSlash } from "react-icons/fa";

export default function ForgetPassword() {
  let { token } = useParams();
  const history = useHistory();
  const location = useLocation();
  const email = new URLSearchParams(location.search).get("email") || "";

  const [newpassword, setNewpassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [forgetEmailError, setforgetEmailError] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formMessage, setFormMessage] = useState("");

  const updatePassword = (e) => {
    e.preventDefault();
    setLoading(true);

    let data = {
      token: token,
      email: email,
      newpassword: newpassword,
    };

    setFormMessage("");
    axios.post(`/api/update-password`, data).then((res) => {
      setLoading(false);
      if (res.data.status === 200) {
        notify(res.data.message || "Your password was changed. Sign in with the new password.");
        history.push("/login");
      } else if (res.data.status === 205) {
        setFormMessage(res.data.message || "This reset link is not valid any more. Ask for a new one.");
      } else {
        setforgetEmailError({
          ...forgetEmailError,
          error_list: res.data.validation_errors,
        });
      }
    }).catch(() => {
      setLoading(false);
    });
  };

  return (
    <div className="auth-container-modern">
      <div className="auth-card-modern">
        <div className="auth-header">
          <h3 className="fw-bold">Set New Password</h3>
          <p>Please enter your new strong password below</p>
        </div>

        <form onSubmit={updatePassword}>
          {formMessage && (
            <div className="alert alert-danger py-2 px-3 small" role="alert">{formMessage}</div>
          )}
          <div className="mb-4">
            <label className="form-label fw-semibold" style={{ fontSize: "13.5px" }}>
              New Password
            </label>
            <div className="input-group">
              <span className="input-group-text bg-light border-end-0">
                <FaLock color="var(--text-muted)" />
              </span>
              <input
                type={showPassword ? "text" : "password"}
                name="newpassword"
                value={newpassword}
                onChange={(e) => setNewpassword(e.target.value)}
                className={`form-control border-start-0 border-end-0 ${
                  forgetEmailError?.error_list?.newpassword ? "is-invalid" : ""
                }`}
                placeholder="Enter new password"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="input-group-text bg-light border-start-0"
                style={{ cursor: "pointer" }}
              >
                {showPassword ? <FaEyeSlash size={14} /> : <FaEye size={14} />}
              </button>
            </div>
            {forgetEmailError?.error_list?.newpassword && (
              <small className="text-danger">
                {forgetEmailError.error_list.newpassword}
              </small>
            )}
          </div>

          <button
            type="submit"
            className="btn btn-primary w-100 py-3 fw-bold rounded-pill"
            style={{ background: "var(--primary)", border: "none" }}
            disabled={loading}
          >
            {loading ? "Updating..." : "Update Password"}
          </button>
        </form>

        <div className="text-center mt-4 pt-3 border-top" style={{ fontSize: "14px" }}>
          <Link to="/login" className="fw-bold" style={{ color: "var(--accent)" }}>
            Return to Sign In
          </Link>
        </div>
      </div>
    </div>
  );
}
